<template>
  <el-checkbox
    v-model="checked"
    @change="change">不分页</el-checkbox>
</template>

<script>
function noop() {}
export default {
  name: 'NoPagerCheckbox',
  props: {
    value: {
      type: Boolean,
      required: true,
      default: false
    },
    pagerYes: {
      type: Function,
      default: noop
    },
    pagerNo: {
      type: Function,
      default: noop
    }
  },
  computed: {
    checked: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    change(bool) {
      this.checked = bool
      console.log(bool)
      if (bool) {
        this.pagerNo()
      } else {
        this.pagerYes()
      }
    }
  }
}
</script>
